import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-certificate',
    templateUrl: './certificate.component.html',
    styleUrls: ['./certificate.component.scss'],
})
export class CertificateComponent extends BaseUI implements AfterViewInit, OnDestroy {
    @Input()
    title = 'test.result.experience';

    @Input()
    experience: string;

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }
}
